import RecaptchaForm from "./RecaptchaForm";
import Analytics from "../utils/Analytics";

const RECAPTCHA_ACTION = "REGISTER";

export default class RegisterPanel extends RecaptchaForm {
    constructor(panelElement) {
        super(panelElement, RECAPTCHA_ACTION);
        this.analytics = new Analytics();
    }

    submitFormData(recaptchaToken) {
        let formData = this.buildBaseFormData(recaptchaToken);
        this.submitToApi(formData, "/en_EN/api/RegisterNewsletter-insert.json");
    }

    postSuccess() {
        this.formElement.dataset["submitted"] = "success";

        this.analytics.sendEventUpdate(
            this.analytics.createUserEvent(["Interface-sidemenu", "Register-tab", "Submit_register_form"]),
        );
    }

    postError() {
        this.formElement.dataset["submitted"] = "failed";
    }
}
